import React from 'react'
import { Card, Button, Box, Typography, Grid } from '@mui/material'
import RFG from "../../libs/inputs/RFG"
import { useDispatch, useSelector } from "react-redux"
import { useForm } from 'react-hook-form'
import { LOGIN } from "../../services/actions"
import {
  BsEyeFill,
  BsEyeSlashFill,
  BsEnvelopeFill,
  BsKeyFill,
  BsArrowRight,
  BsArrowLeft,
  BsShieldCheck,
  BsCloudCheckFill,
  BsExclamationTriangleFill,
  BsShieldLockFill,
  BsLightningChargeFill,
  BsLayersFill
} from "react-icons/bs"
import { useNavigate } from 'react-router-dom'
import authImg from './auth.jpeg'
import OtpTimer from './OtpTimer'

const CustomInput = React.forwardRef(({ icon: Icon, isPassword, style, className, onFocus, onBlur, ...props }, ref) => {
  const [isFocused, setIsFocused] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      minHeight: '52px',
      background: isFocused ? 'rgba(15, 23, 42, 0.95)' : 'rgba(15, 23, 42, 0.75)',
      border: '1.5px solid',
      borderColor: isFocused ? '#38bdf8' : 'rgba(255, 255, 255, 0.15)',
      borderRadius: '12px',
      px: 2,
      py: 0.5,
      transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
      boxShadow: isFocused ? '0 0 0 4px rgba(56, 189, 248, 0.2), 0 4px 14px rgba(0, 0, 0, 0.25)' : '0 2px 6px rgba(0, 0, 0, 0.15)',
      '&:hover': {
        borderColor: isFocused ? '#38bdf8' : 'rgba(255, 255, 255, 0.3)',
        background: 'rgba(15, 23, 42, 0.95)'
      }
    }}>
      {Icon && (
        <Box sx={{
          color: isFocused ? '#38bdf8' : '#94a3b8',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          mr: 1.5,
          transition: 'color 0.25s',
          fontSize: '18px',
          flexShrink: 0
        }}>
          <Icon />
        </Box>
      )}
      <input
        ref={ref}
        {...props}
        className={`auth-custom-input ${className || ''}`}
        type={isPassword ? (showPassword ? "text" : "password") : (props.type || "text")}
        onFocus={(e) => {
          setIsFocused(true);
          onFocus && onFocus(e);
        }}
        onBlur={(e) => {
          setIsFocused(false);
          onBlur && onBlur(e);
        }}
        style={{
          border: 'none',
          background: 'transparent',
          backgroundColor: 'transparent',
          color: '#ffffff',
          padding: '12px 0',
          width: '100%',
          fontSize: '15px',
          outline: 'none',
          boxShadow: 'none',
          fontFamily: "'Inter', 'Outfit', sans-serif",
          fontWeight: 500,
          ...style
        }}
      />
      {isPassword && (
        <Box
          onClick={() => setShowPassword(!showPassword)}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 34,
            height: 34,
            borderRadius: '8px',
            color: showPassword ? '#38bdf8' : '#94a3b8',
            background: showPassword ? 'rgba(56, 189, 248, 0.12)' : 'transparent',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            ml: 1,
            flexShrink: 0,
            '&:hover': {
              color: '#ffffff',
              background: 'rgba(255, 255, 255, 0.08)'
            }
          }}
          title={showPassword ? "Hide passcode" : "Show passcode"}
        >
          {showPassword ? <BsEyeSlashFill size={18} /> : <BsEyeFill size={18} />}
        </Box>
      )}
    </Box>
  );
});

export default function Login() {
  const navigate = useNavigate()
  let dispatch = useDispatch()
  let user = useSelector((state) => state?.loginState.auth)
  const [verify, setVerify] = React.useState(false)
  const [startTimer, setStartTimer] = React.useState(false)
  const [erroMsg, setErrorMsg] = React.useState("")
  const [otpSubmitted, setOtpSubmitted] = React.useState(false)
  const { handleSubmit, control } = useForm({
    mode: "all"
  })

  React.useEffect(() => {
    console.log("RESULT", user ? "user" : "anonymous", user)
    if (Object.keys(user || {}).length && user?.status) {
      console.log("EXPIRY1", localStorage.expiry)
      localStorage.expiry = (!localStorage.expiry || Number(localStorage.expiry) <= 0) ? user.expiry : localStorage.expiry
      console.log("EXPIRY", localStorage.expiry)
      if (verify) setStartTimer(true)
      setErrorMsg("")
    } else if (verify && otpSubmitted) {
      setErrorMsg(user?.message || "Invalid OTP")
    }
  }, [user, otpSubmitted, verify])

  return (
    <>
      <style>{`
        /* Auth Custom Input styling to override any global input styles */
        .auth-custom-input,
        input.auth-custom-input,
        input.auth-custom-input[type="text"],
        input.auth-custom-input[type="password"],
        input.auth-custom-input[type="email"] {
          border: none !important;
          background: transparent !important;
          background-color: transparent !important;
          color: #ffffff !important;
          padding: 10px 0 !important;
          width: 100% !important;
          font-size: 15px !important;
          outline: none !important;
          box-shadow: none !important;
          border-radius: 0px !important;
          font-family: 'Inter', 'Outfit', sans-serif !important;
          font-weight: 500 !important;
        }

        .auth-custom-input:focus,
        input.auth-custom-input:focus,
        input.auth-custom-input[type="text"]:focus,
        input.auth-custom-input[type="password"]:focus {
          border: none !important;
          background: transparent !important;
          background-color: transparent !important;
          outline: none !important;
          box-shadow: none !important;
        }

        .auth-custom-input::placeholder,
        input.auth-custom-input::placeholder {
          color: #64748b !important;
          opacity: 1 !important;
        }

        /* Completely override browser autofill white box styling */
        input:-webkit-autofill,
        input:-webkit-autofill:hover,
        input:-webkit-autofill:focus,
        input:-webkit-autofill:active {
          -webkit-box-shadow: 0 0 0 1000px #0f172a inset !important;
          -webkit-text-fill-color: #ffffff !important;
          caret-color: #ffffff !important;
          border-radius: 0px !important;
          transition: background-color 5000s ease-in-out 0s !important;
        }

        @keyframes floatSlow {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        @keyframes pulseGlow {
          0%, 100% { opacity: 0.25; transform: scale(1); }
          50% { opacity: 0.5; transform: scale(1.08); }
        }
        @keyframes fadeInSlide {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in {
          animation: fadeInSlide 0.4s cubic-bezier(0.16, 1, 0.3, 1) forwards;
        }
        .hover-card-effect {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        .hover-card-effect:hover {
          transform: translateY(-4px);
          background: rgba(255, 255, 255, 0.08) !important;
          border-color: rgba(56, 189, 248, 0.4) !important;
          box-shadow: 0 12px 24px -10px rgba(0, 0, 0, 0.5);
        }
      `}</style>

      <Box sx={{
        width: '100%',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#090d16',
        fontFamily: "'Inter', 'Outfit', sans-serif",
        position: 'relative',
        overflow: 'hidden',
        p: { xs: 2, sm: 3, md: 4 }
      }}>
        {/* Ambient animated background orbs */}
        <Box sx={{
          position: 'absolute',
          top: '-10%',
          left: '-5%',
          width: '45vw',
          height: '45vw',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(14, 165, 233, 0.18) 0%, rgba(0, 0, 0, 0) 70%)',
          filter: 'blur(70px)',
          animation: 'pulseGlow 8s infinite ease-in-out',
          zIndex: 0,
          pointerEvents: 'none',
        }} />
        <Box sx={{
          position: 'absolute',
          bottom: '-15%',
          right: '-5%',
          width: '50vw',
          height: '50vw',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(99, 102, 241, 0.18) 0%, rgba(0, 0, 0, 0) 70%)',
          filter: 'blur(90px)',
          animation: 'pulseGlow 10s infinite ease-in-out reverse',
          zIndex: 0,
          pointerEvents: 'none',
        }} />

        <Card sx={{
          position: 'relative',
          zIndex: 1,
          maxWidth: 1180,
          width: '100%',
          background: 'rgba(15, 23, 42, 0.65) !important',
          backdropFilter: 'blur(24px)',
          WebkitBackdropFilter: 'blur(24px)',
          border: '1px solid rgba(255, 255, 255, 0.1) !important',
          boxShadow: '0 30px 60px -12px rgba(0, 0, 0, 0.7), 0 0 0 1px rgba(255, 255, 255, 0.05) !important',
          color: '#ffffff',
          borderRadius: { xs: 3, md: 5 },
          overflow: 'hidden'
        }}>
          <Grid container>
            {/* Left Column (Login Form) */}
            <Grid size={{ xs: 12, sm: 12, md: 5 }}>
              <Box sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                minHeight: { xs: 'auto', md: '680px', lg: '740px' },
                p: { xs: 3.5, sm: 5, md: 5, lg: 6 },
                position: 'relative',
                zIndex: 2
              }}>
                <Box sx={{ width: '100%', maxWidth: '380px', mx: 'auto' }}>
                  
                  {/* Brand Header */}
                  <Box display="flex" alignItems="center" gap={1.5} sx={{ mb: 4 }}>
                    <Box sx={{
                      width: 42,
                      height: 42,
                      borderRadius: '12px',
                      background: 'linear-gradient(135deg, #38bdf8 0%, #6366f1 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      boxShadow: '0 8px 20px -4px rgba(56, 189, 248, 0.4)'
                    }}>
                      <BsShieldLockFill size={20} color="#ffffff" />
                    </Box>
                    <Box>
                      <Typography fontSize={18} fontWeight={800} sx={{
                        letterSpacing: '-0.5px',
                        background: 'linear-gradient(135deg, #ffffff 0%, #cbd5e1 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        lineHeight: 1.2
                      }}>
                        WORK AXIS
                      </Typography>
                      <Typography fontSize={11} color="#64748b" fontWeight={600} letterSpacing="1px">
                        ENTERPRISE TMS
                      </Typography>
                    </Box>
                  </Box>

                  {/* Step Title & Subtitle */}
                  <Box sx={{ mb: 4 }} className="animate-fade-in">
                    {verify ? (
                      <>
                        <Box sx={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: 0.8,
                          px: 1.5,
                          py: 0.6,
                          borderRadius: '20px',
                          background: 'rgba(56, 189, 248, 0.12)',
                          border: '1px solid rgba(56, 189, 248, 0.25)',
                          color: '#38bdf8',
                          fontSize: 12,
                          fontWeight: 600,
                          mb: 2
                        }}>
                          <BsShieldCheck size={14} /> 2-Factor Authentication
                        </Box>
                        <Typography fontSize={26} fontWeight={800} color="#ffffff" sx={{ letterSpacing: '-0.5px' }}>
                          Verify Identity
                        </Typography>
                        <Typography fontSize={14} sx={{ mt: 1, color: '#94a3b8', lineHeight: 1.5 }}>
                          We've sent a one-time verification passcode to your registered email address.
                        </Typography>
                      </>
                    ) : (
                      <>
                        <Typography fontSize={26} fontWeight={800} color="#ffffff" sx={{ letterSpacing: '-0.5px' }}>
                          Sign In Access
                        </Typography>
                        <Typography fontSize={14} sx={{ mt: 1, color: '#94a3b8', lineHeight: 1.5 }}>
                          Welcome to Work Axis document management system. Please enter your credentials to continue.
                        </Typography>
                      </>
                    )}
                  </Box>

                  {/* Form */}
                  <form autoComplete="false" onSubmit={handleSubmit((data) => {
                    setErrorMsg("")
                    if (!verify) {
                      data.verify = false;
                      if (!data.password) {
                        data.password = "0000";
                      }
                      setOtpSubmitted(false);
                      setVerify(true);
                      dispatch({ type: `${LOGIN}_AUTH`, payload: data });
                    } else {
                      data.verify = true;
                      setOtpSubmitted(true);
                      dispatch({ type: `${LOGIN}_AUTH`, payload: data });
                    }
                  })}>
                    {!verify && (
                      <Box className="animate-fade-in">
                        <RFG
                          labelStyle={{ color: "#e2e8f0", fontSize: "13px", fontWeight: 600, marginBottom: "8px", display: "block", letterSpacing: "0.3px" }}
                          name="username"
                          label="Email as Username"
                          control={control}
                          rules={{ required: true }}
                          className="mb-3"
                        >
                          <CustomInput icon={BsEnvelopeFill} placeholder="name@company.com" autoComplete="off" />
                        </RFG>
                      </Box>
                    )}

                    {verify && (
                      <Box className="animate-fade-in">
                        <RFG
                          labelStyle={{ color: "#e2e8f0", fontSize: "13px", fontWeight: 600, marginBottom: "8px", display: "block", letterSpacing: "0.3px" }}
                          name="password"
                          label="One-Time Passcode (OTP)"
                          control={control}
                          rules={{ required: true }}
                          className="mb-2"
                        >
                          <CustomInput icon={BsKeyFill} placeholder="Enter 4-6 digit OTP" isPassword={true} />
                        </RFG>

                        <Box sx={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          mt: 2,
                          p: 1.5,
                          px: 2,
                          borderRadius: '10px',
                          background: 'rgba(255, 255, 255, 0.02)',
                          border: '1px solid rgba(255, 255, 255, 0.06)'
                        }}>
                          <Box sx={{ fontSize: 13, color: "#cbd5e1", fontWeight: 500, display: 'flex', alignItems: 'center', gap: 1 }}>
                            {(user?.status && startTimer) && <OtpTimer expiry={localStorage.expiry} />}
                          </Box>
                          <Typography
                            sx={{
                              fontSize: 13,
                              color: "#38bdf8",
                              cursor: 'pointer',
                              fontWeight: 600,
                              transition: 'all 0.2s',
                              '&:hover': { color: '#7dd3fc', textDecoration: 'underline' }
                            }}
                            onClick={() => { navigate('/forgot-password/') }}
                          >
                            Resend OTP
                          </Typography>
                        </Box>
                      </Box>
                    )}

                    {/* Submit / Back Buttons */}
                    <Box display="flex" justifyContent="space-between" gap={2} sx={{ mt: 4 }}>
                      {verify && (
                        <Button
                          data-testid="btn_verify"
                          onClick={() => { setVerify(false); setOtpSubmitted(false); setErrorMsg("") }}
                          sx={{
                            color: "#e2e8f0",
                            width: '40%',
                            py: 1.5,
                            background: 'rgba(255, 255, 255, 0.05)',
                            border: '1px solid rgba(255, 255, 255, 0.12)',
                            borderRadius: '12px',
                            textTransform: 'none',
                            fontSize: '14px',
                            fontWeight: 600,
                            transition: 'all 0.25s',
                            '&:hover': {
                              background: 'rgba(255, 255, 255, 0.1)',
                              borderColor: 'rgba(255, 255, 255, 0.2)',
                              transform: 'translateY(-2px)'
                            }
                          }}
                        >
                          <Box component="span" display="flex" alignItems="center" gap={1}>
                            <BsArrowLeft /> Back
                          </Box>
                        </Button>
                      )}
                      <Button
                        data-testid="btn_login"
                        type="submit"
                        sx={{
                          color: "white",
                          width: verify ? '60%' : '100%',
                          py: 1.5,
                          background: 'linear-gradient(135deg, #0284c7 0%, #3b82f6 50%, #6366f1 100%)',
                          backgroundSize: '200% auto',
                          borderRadius: '12px',
                          textTransform: 'none',
                          fontSize: '15px',
                          fontWeight: 600,
                          boxShadow: '0 10px 25px -5px rgba(59, 130, 246, 0.5)',
                          transition: 'all 0.3s ease',
                          '&:hover': {
                            backgroundPosition: 'right center',
                            transform: 'translateY(-2px)',
                            boxShadow: '0 15px 30px -5px rgba(59, 130, 246, 0.65)'
                          },
                          '&:active': {
                            transform: 'translateY(0px)'
                          }
                        }}
                      >
                        <Box component="span" display="flex" alignItems="center" justifyContent="center" gap={1}>
                          {verify ? "Verify Account" : "Continue with Email"}
                          <BsArrowRight />
                        </Box>
                      </Button>
                    </Box>
                  </form>

                  {/* Error & Status Messages */}
                  {erroMsg && (
                    <Box sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1.5,
                      mt: 3,
                      p: 1.5,
                      px: 2,
                      borderRadius: '10px',
                      background: 'rgba(239, 68, 68, 0.1)',
                      border: '1px solid rgba(239, 68, 68, 0.25)',
                      color: '#fca5a5',
                      fontSize: 13,
                      fontWeight: 500
                    }} className="animate-fade-in">
                      <BsExclamationTriangleFill style={{ minWidth: 16, color: '#ef4444' }} />
                      <span>{erroMsg}</span>
                    </Box>
                  )}

                  {/* Trust Badges */}
                  <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 3,
                    mt: 4,
                    pt: 3,
                    borderTop: '1px solid rgba(255, 255, 255, 0.08)'
                  }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, color: '#64748b', fontSize: 12, fontWeight: 500 }}>
                      <BsShieldCheck color="#38bdf8" size={15} />
                      <span>256-bit SSL Secure</span>
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, color: '#64748b', fontSize: 12, fontWeight: 500 }}>
                      <BsCloudCheckFill color="#38bdf8" size={15} />
                      <span>Real-time Sync</span>
                    </Box>
                  </Box>

                  {/* Footer */}
                  <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ mt: 5 }}>
                    <Typography sx={{ fontSize: 12, color: "#64748b", fontWeight: 500 }}>
                      Powered by Work Axis
                    </Typography>
                    <Box display="flex" gap={2}>
                      <Typography sx={{ fontSize: 12, color: "#64748b", cursor: 'pointer', transition: 'color 0.2s', '&:hover': { color: '#cbd5e1' } }}>
                        Privacy
                      </Typography>
                      <Typography sx={{ fontSize: 12, color: "#64748b", cursor: 'pointer', transition: 'color 0.2s', '&:hover': { color: '#cbd5e1' } }}>
                        Terms & Conditions
                      </Typography>
                    </Box>
                  </Box>

                </Box>
              </Box>
            </Grid>

            {/* Right Column (Showcase / Branding) */}
            <Grid size={{ xs: 12, sm: 12, md: 7 }} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
              <Box sx={{
                width: '100%',
                height: '100%',
                minHeight: '680px',
                position: 'relative',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'space-between',
                p: { md: 5, lg: 6 }
              }}>
                {/* Background Image with Scale Animation */}
                <img
                  style={{
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    transform: 'scale(1.03)',
                    transition: 'transform 10s ease',
                    filter: 'brightness(0.85) contrast(1.1)'
                  }}
                  src={authImg}
                  alt="Authentication background"
                />

                {/* Dark Atmospheric Gradient Overlays */}
                <Box sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(135deg, rgba(15, 23, 42, 0.90) 0%, rgba(30, 41, 59, 0.72) 50%, rgba(15, 23, 42, 0.95) 100%)',
                  zIndex: 1
                }} />
                <Box sx={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '140px',
                  bottom: 0,
                  background: 'linear-gradient(90deg, rgba(15, 23, 42, 1) 0%, rgba(15, 23, 42, 0) 100%)',
                  zIndex: 2
                }} />

                {/* Top Status Bar */}
                <Box sx={{ position: 'relative', zIndex: 3, display: 'flex', justifyContent: 'flex-end' }}>
                  <Box sx={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: 1,
                    px: 2,
                    py: 0.8,
                    borderRadius: '20px',
                    background: 'rgba(255, 255, 255, 0.08)',
                    backdropFilter: 'blur(12px)',
                    border: '1px solid rgba(255, 255, 255, 0.15)',
                    color: '#e2e8f0',
                    fontSize: 12,
                    fontWeight: 600,
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                  }}>
                    <span style={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      backgroundColor: '#4ade80',
                      display: 'inline-block',
                      boxShadow: '0 0 10px #4ade80'
                    }} />
                    System Operational • v2.4
                  </Box>
                </Box>

                {/* Center Content & Feature Highlights */}
                <Box sx={{ position: 'relative', zIndex: 3, my: 'auto', py: 4 }}>
                  <Box sx={{ display: 'inline-flex', alignItems: 'center', gap: 1, px: 1.8, py: 0.6, borderRadius: '8px', background: 'rgba(56, 189, 248, 0.15)', border: '1px solid rgba(56, 189, 248, 0.3)', color: '#38bdf8', fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '1.5px', mb: 2.5 }}>
                    <BsLightningChargeFill /> Enterprise TMS Platform
                  </Box>
                  <Typography variant="h3" sx={{
                    fontWeight: 800,
                    fontSize: { md: '32px', lg: '40px' },
                    lineHeight: 1.2,
                    color: '#ffffff',
                    mb: 2.5,
                    letterSpacing: '-0.8px'
                  }}>
                    Manage Workflows & Teams <br />
                    <span style={{
                      background: 'linear-gradient(135deg, #38bdf8 0%, #818cf8 50%, #c084fc 100%)',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent'
                    }}>
                      With Unmatched Precision.
                    </span>
                  </Typography>
                  <Typography sx={{ color: '#94a3b8', fontSize: '15px', lineHeight: 1.6, maxWidth: '480px', mb: 4.5 }}>
                    Experience real-time collaboration, automated task tracking, and secure document archiving in one unified workspace.
                  </Typography>

                  {/* Interactive Feature Cards Grid */}
                  <Grid container spacing={2} sx={{ maxWidth: '580px' }}>
                    {[
                      { icon: BsShieldLockFill, title: "Role-Based Security", desc: "Granular access control & audit logs." },
                      { icon: BsLightningChargeFill, title: "Real-Time SSE Sync", desc: "Live push notifications & instant updates." },
                      { icon: BsLayersFill, title: "Smart Document Hub", desc: "Version-controlled storage & previews." },
                      { icon: BsCloudCheckFill, title: "Cloud Architecture", desc: "99.9% uptime with automated backups." },
                    ].map((item, idx) => {
                      const IconComponent = item.icon;
                      return (
                        <Grid size={{ xs: 12, sm: 6 }} key={idx}>
                          <Box
                            className="hover-card-effect"
                            sx={{
                              p: 2,
                              borderRadius: '14px',
                              background: 'rgba(255, 255, 255, 0.04)',
                              backdropFilter: 'blur(10px)',
                              border: '1px solid rgba(255, 255, 255, 0.08)',
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: 1.5,
                              cursor: 'default'
                            }}
                          >
                            <Box sx={{
                              p: 1,
                              borderRadius: '10px',
                              background: 'rgba(56, 189, 248, 0.15)',
                              color: '#38bdf8',
                              display: 'flex',
                              mt: 0.2
                            }}>
                              <IconComponent size={18} />
                            </Box>
                            <Box>
                              <Typography sx={{ color: '#f1f5f9', fontSize: 14, fontWeight: 700, mb: 0.3 }}>
                                {item.title}
                              </Typography>
                              <Typography sx={{ color: '#64748b', fontSize: 12, lineHeight: 1.4 }}>
                                {item.desc}
                              </Typography>
                            </Box>
                          </Box>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>

                {/* Bottom Testimonial / Quote */}
                <Box sx={{ position: 'relative', zIndex: 3 }}>
                  <Box sx={{
                    p: 2.5,
                    borderRadius: '16px',
                    background: 'rgba(15, 23, 42, 0.65)',
                    backdropFilter: 'blur(16px)',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2.5,
                    boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
                    animation: 'floatSlow 6s infinite ease-in-out'
                  }}>
                    <Box sx={{
                      width: 44,
                      height: 44,
                      borderRadius: '50%',
                      background: 'linear-gradient(135deg, #38bdf8 0%, #6366f1 100%)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 700,
                      fontSize: 16,
                      color: '#ffffff',
                      flexShrink: 0,
                      boxShadow: '0 4px 12px rgba(56, 189, 248, 0.4)'
                    }}>
                      WA
                    </Box>
                    <Box>
                      <Typography sx={{ color: '#e2e8f0', fontSize: 13, fontStyle: 'italic', mb: 0.5, lineHeight: 1.5 }}>
                        "Work Axis transformed our document review cycles and team accountability, cutting project turnaround time by half."
                      </Typography>
                      <Typography sx={{ color: '#38bdf8', fontSize: 12, fontWeight: 700 }}>
                        Enterprise Operations Director <span style={{ color: '#64748b', fontWeight: 500 }}>• Verified Client</span>
                      </Typography>
                    </Box>
                  </Box>
                </Box>

              </Box>
            </Grid>
          </Grid>
        </Card>
      </Box>
    </>
  )
}



